import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';
import { ServiceGrid } from '../components/ServiceCard';
import { useServices } from '../hooks/useServices';

export default function ServicesPage() {
  const { t, lp } = useLanguage();
  const services = useServices();

  return (
    <div data-testid="services-page">
      <SEO />
      <section className="relative py-20 md:py-28 bg-[#0F172A]">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)', backgroundSize: '40px 40px'}} />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 md:px-8">
          <span className="inline-block text-[#3b8dff] text-sm font-semibold uppercase tracking-wider mb-4">{t('services.tag')}</span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-6 max-w-4xl" data-testid="services-title">{t('servicesPage.title')}</h1>
          <p className="text-slate-400 text-lg max-w-2xl">{t('servicesPage.subtitle')}</p>
        </div>
      </section>

      <section className="py-20 md:py-28 blueprint-bg" data-testid="services-overview">
        <div className="max-w-[1480px] mx-auto px-4 md:px-8">
          <ServiceGrid services={services} />
        </div>
      </section>

      <section className="py-20 bg-white border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col lg:flex-row lg:items-center justify-between gap-8">
          <div className="max-w-2xl">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#0F172A] mb-3">{t('cta.title')}</h2>
            <p className="text-slate-600">{t('cta.subtitle')}</p>
          </div>
          <div className="flex flex-wrap gap-4">
            <Link to={lp('/contact')}>
              <Button className="bg-[#066ce7] hover:bg-[#005bb5] text-white px-7 h-12 text-base font-semibold" data-testid="services-cta-contact">
                {t('cta.btn2')} <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
            <Link to={lp('/planner')}>
              <Button variant="outline" className="border-2 border-slate-200 hover:border-[#066ce7] hover:text-[#066ce7] px-7 h-12 text-base font-semibold" data-testid="services-cta-planner">
                {t('cta.btn1')}
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
